import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";

export const Team = () => {
  const { t } = useTranslation();
  const teamData = [
    {
      profile: "assets/images/team/teammate6.jpg",
      name: "MSc. M.A. José Bagur",
      description2: "Departamento de Ingeniería Mecánica",
      description: "Universidad del Valle de Guatemala",
      position: "Coordinador del Laboratorio Aeroespacial",
      linkedinUrl: "https://www.linkedin.com/in/joseantoniobagur/",
    },
    {
      profile: "assets/images/team/teammate2.png",
      name: "Dra. Leonora de Lemos",
      description: "Universidad de Costa Rica",
      position: "Vicerrectora de Vida Estudiantil",
      linkedinUrl: "https://www.linkedin.com/in/leonora-de-lemos-116b56ab/",
    },
    {
      profile: "assets/images/team/teammate5.png",
      name: "Licda. Katherinne Herrera-Jordan",
      description: "Verne Technologies",
      position: "Fundadora y Directora",
      linkedinUrl:
        "https://www.linkedin.com/in/katherinne-herrera-jordan-780904154/",
    },
    {
      profile: "assets/images/team/teammate4.png",
      name: "Dr. Javier Mejuto",
      description: "Universidad Nacional Autónoma de Honduras",
      position: "Decano de la Facultad de Ciencias Espaciales",
      linkedinUrl: "https://www.linkedin.com/in/javier-mejuto-44262426/",
    },
    {
      profile: "assets/images/team/teammate1.png",
      name: "Dr. Andrés Mora",
      description: "NASA Ames Research Center",
      position: "Flight Instrument Group",
      linkedinUrl: "https://www.linkedin.com/in/andresmora/",
    },
    {
      profile: "assets/images/team/teammate3.png",
      name: "Dr. Luis Zea",
      position: "Profesor Adjunto",
      description: "Universidad de Colorado Boulder",
      linkedinUrl: "https://www.linkedin.com/in/spaceluiszea/",
    }
  ];

  const localTeamData = [
    {
      profile: "assets/images/team/teammate9.jpg",
      name: "Ing. Lourdes Figueroa",
      description2: "Facultad de Ingeniería",
      description: "Universidad del Valle de Guatemala",
      position: "Project Manager",
      linkedinUrl: "https://www.linkedin.com/in/lourdes-figueroa-9827ba1a0/"
    },
    {
      profile: "assets/images/team/teammate10.png",
      name: "Ing. Mario Gálvez",
      description2: "Junta Directiva",
      description: "Asociación Guatemalteca de Ingeniería y Ciencias Espaciales (AGICE)",
      position: "Presidente",
      linkedinUrl: "https://www.linkedin.com/in/mario-galvez-gt97/"
    },
    {
      profile: "assets/images/team/teammate7.png",
      name: "Ing. César Saavedra",
      description2: "Departamento de Ingeniería Mecánica",
      description: "Universidad del Valle de Guatemala",
      position: "Investigador del Laboratorio Aeroespacial",
      linkedinUrl: "https://www.linkedin.com/in/cesar-saavedra-m/"
    },
    {
      profile: "assets/images/team/teammate8.png",
      name: "MSc. Héctor Gómez",
      description2: "Departamento de Ingeniería Mecánica",
      description: "Universidad del Valle de Guatemala",
      position: "Investigador del Laboratorio Aeroespacial",
      linkedinUrl: "https://www.linkedin.com/in/h%C3%A9ctor-francisco-g%C3%B3mez-hern%C3%A1ndez-98994b163/"
    },
  ];

  const renderIcons = (teammate) => (
    <ul className="list-inline team-social mt-3 mb-0">
      {teammate.linkedinUrl && (
        <li className="list-inline-item">
          <a target="_blank" rel="noreferrer" href={teammate.linkedinUrl}>
            <i className="fab fa-linkedin" style={{ fontSize: '1.5rem', color: '#0077b5' }} />
          </a>
        </li>
      )}
      {teammate.scholarUrl && (
        <li className="list-inline-item">
          <a target="_blank" rel="noreferrer" href={teammate.scholarUrl}>
            <i className="fas fa-graduation-cap" style={{ fontSize: '1.5rem', color: '#666' }} />
          </a>
        </li>
      )}
      {teammate.researchgateUrl && (
        <li className="list-inline-item">
          <a target="_blank" rel="noreferrer" href={teammate.researchgateUrl}>
            <i className="fas fa-flask" style={{ fontSize: '1.5rem', color: '#00ccbb' }} />
          </a>
        </li>
      )}
    </ul>
  );

  return (
    <section className="section" style={{ backgroundColor: '#f8f9fa', paddingTop: '0' }} id="team">
      <Container>
        {/* Comité Organizador - Sin título aquí porque ya está en AboutContent */}
        <Row>
          {teamData.map((teammate, key) => (
            <Col lg={4} key={key} className="mb-4">
              <div className="team-box" style={{
                backgroundColor: '#ffffff',
                border: '1px solid #dee2e6',
                borderRadius: '10px',
                padding: '30px 20px',
                height: '100%',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 5px 20px rgba(0,0,0,0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
              }}
              >
                <img
                  src={teammate.profile}
                  alt={teammate.name}
                  className="rounded-circle mx-auto d-block mb-3"
                  style={{ 
                    width: "150px", 
                    height: "150px", 
                    objectFit: "cover",
                    border: '4px solid #f0f0f0'
                  }}
                />
                <div style={{ minHeight: '180px' }}>
                  <h5 style={{ 
                    color: '#2c3e50',
                    fontWeight: 'bold',
                    marginBottom: '15px'
                  }}>
                    {t(teammate.name)}
                  </h5>
                  <p style={{ 
                    color: '#007bff',
                    fontWeight: '500',
                    marginBottom: '10px' 
                  }}>
                    {t(teammate.position)}
                  </p>
                  {teammate.description1 && (
                    <p style={{ 
                      color: '#6c757d',
                      fontSize: '0.95rem',
                      marginBottom: '5px'
                    }}>
                      {t(teammate.description1)}
                    </p>
                  )}
                  {teammate.description2 && (
                    <p style={{ 
                      color: '#6c757d',
                      fontSize: '0.95rem',
                      marginBottom: '5px'
                    }}>
                      {t(teammate.description2)}
                    </p>
                  )}
                  {/* Para compatibilidad con el formato antiguo */}
                  {teammate.description && (
                    <p style={{ 
                      color: '#6c757d',
                      fontSize: '0.95rem' 
                    }}>
                      {t(teammate.description)}
                    </p>
                  )}
                  {teammate.position2 && teammate.description2 && (
                    <>
                      <p style={{ 
                        color: '#007bff',
                        fontWeight: '500',
                        marginBottom: '10px',
                        marginTop: '15px'
                      }}>
                        {t(teammate.position2)}
                      </p>
                      <p style={{ 
                        color: '#6c757d',
                        fontSize: '0.95rem' 
                      }}>
                        {t(teammate.description2)}
                      </p>
                    </>
                  )}
                </div>
                {renderIcons(teammate)}
              </div>
            </Col>
          ))}
        </Row>

        {/* Comité Organizador Local */}
        <Row className="justify-content-center text-center mt-5 mb-5">
          <Col lg={12}>
            <h2 style={{ 
              color: '#333333',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              {t("COMITÉ ORGANIZADOR LOCAL")}
            </h2>
            <p style={{ color: '#666666' }} className="lead">
              {t("Equipo local de la Universidad del Valle de Guatemala (UVG)")}
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          {localTeamData.map((teammate, key) => (
            <Col lg={4} key={key} className="mb-4">
              <div className="team-box" style={{
                backgroundColor: '#ffffff',
                border: '1px solid #dee2e6',
                borderRadius: '10px',
                padding: '30px 20px',
                height: '100%',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 5px 20px rgba(0,0,0,0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
              }}
              >
                <img
                  src={teammate.profile}
                  alt={teammate.name}
                  className="rounded-circle mx-auto d-block mb-3"
                  style={{ 
                    width: "150px", 
                    height: "150px", 
                    objectFit: "cover",
                    border: '4px solid #f0f0f0'
                  }}
                />
                <div style={{ minHeight: '180px' }}>
                  <h5 style={{ 
                    color: '#2c3e50',
                    fontWeight: 'bold',
                    marginBottom: '15px'
                  }}>
                    {t(teammate.name)}
                  </h5>
                  <p style={{ 
                    color: '#007bff',
                    fontWeight: '500',
                    marginBottom: '10px' 
                  }}>
                    {t(teammate.position)}
                  </p>
                  {teammate.description1 && (
                    <p style={{ 
                      color: '#6c757d',
                      fontSize: '0.95rem',
                      marginBottom: '5px'
                    }}>
                      {t(teammate.description1)}
                    </p>
                  )}
                  {teammate.description2 && (
                    <p style={{ 
                      color: '#6c757d',
                      fontSize: '0.95rem',
                      marginBottom: '5px'
                    }}>
                      {t(teammate.description2)}
                    </p>
                  )}
                  {/* Para compatibilidad con el formato antiguo */}
                  {teammate.description && (
                    <p style={{ 
                      color: '#6c757d',
                      fontSize: '0.95rem' 
                    }}>
                      {t(teammate.description)}
                    </p>
                  )}
                </div>
                {renderIcons(teammate)}
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};